import React, { useCallback, useEffect } from 'react'
import cn from 'classnames'
import { Button, InterfaceStarFilledIcon } from '@grammarly/design-system'
import { navHelper } from '@lib/services/navigation'
import { getConfig } from '../../config'
import ctaButtonStyles from '@components/item/cta-button/cta-button.module.scss'
import styles from './plans-cta-button.module.scss'

const DEFAULT_PLANS_URL = `${getConfig().urls.main}/plans`

export type PlansCtaButtonWrapper = 'none' | 'cta'

export interface PlansCtaButtonProps {
  text: string
  variant: React.ComponentProps<typeof Button>['variant']
  size?: React.ComponentProps<typeof Button>['size']
  iconStart?: React.ComponentProps<typeof Button>['iconStart']
  isInverted?: boolean
  wrapper?: PlansCtaButtonWrapper
  onShow?: () => void
  onClick?: () => void | Promise<void>
  className?: string
}

export const PlansCtaButton: React.FC<PlansCtaButtonProps> = (props) => {
  const {
    text,
    variant,
    size = 'medium',
    iconStart = InterfaceStarFilledIcon,
    isInverted = false,
    wrapper = 'none',
    onShow,
    onClick,
    className,
  } = props

  useEffect(() => {
    onShow?.()
  }, [onShow])

  const handleClick = useCallback(async () => {
    try {
      await onClick?.()
    } finally {
      navHelper.navigateUrl(DEFAULT_PLANS_URL)
    }
  }, [onClick])

  const button = (
    <Button
      variant={variant}
      onClick={handleClick}
      size={size}
      iconStart={iconStart}
      text={text}
      className={cn(className, { [styles.invertedProButton]: isInverted })}
    />
  )

  if (wrapper === 'cta') {
    return (
      <div className={ctaButtonStyles.ctaContainer}>
        <div className={ctaButtonStyles.ctaButtonAndUnderLinkContainer}>{button}</div>
      </div>
    )
  }

  return button
}
